import cmp from './Answers'

export default cmp
